import React from 'react'
import { inject, observer } from "mobx-react"
import { toJS, isObservableArray } from 'mobx'
import ConditionalWrapperBuilderPreview from './ConditionalWrapperBuilderPreview'
import elementsForField from '../util/elementsForField.js'

const ConditionalWrapper = observer(({ store, field, children }) => {
  const { name, conditional } = field

  // If this field is not conditional, always render
  if(!conditional || !field.conditions || field.conditions.length == 0) {
    return children
  }

  // We're in builder mode -- always render it but show an indicator that it is conditional
  if(store.buildable) {
    return <ConditionalWrapperBuilderPreview field={field}>{children}</ConditionalWrapperBuilderPreview>
  }

  const shouldDisplayField = store.shouldDisplayField(field)

  if(shouldDisplayField) {
    return children
  }
  else {
    return null
  }
})

export default inject("store")(ConditionalWrapper)
